// This file was auto-generated using scripts/generate-icons.js

/**
 * Icon generated from groups-filled.svg
 *
 * @param {import('preact').JSX.SVGAttributes<SVGSVGElement>} props
 */
export default function GroupsFilledIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      aria-hidden="true"
      {...props}
    >
      <path
        fill="currentColor"
        d="M4 11a4 4 0 0 1 4 4 1 1 0 0 1-.883.993L7 16H1a1 1 0 0 1-1-1 4 4 0 0 1 4-4Zm8-4a4 4 0 0 1 4 4 1 1 0 0 1-.883.993L15 12H9a1 1 0 0 1-1-1 4 4 0 0 1 4-4ZM4 4a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm8-4a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
      />
    </svg>
  );
}
